export default __webpack_public_path__ + "static/media/Seasons_15.bb645256.png";